/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { workspacesRetrieveList } from "../../funcs/workspacesRetrieveList.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request:
    operations.GetApiWorkspaceServiceV1WorkspacesListRequest$inboundSchema,
};

export const tool$workspacesRetrieveList: ToolDefinition<typeof args> = {
  name: "workspaces_retrieve-list",
  description: `List workspaces`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await workspacesRetrieveList(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
